import type { NavigationToggleType } from '@/storyblok/wirfuersklima/header/Header';
import classNames from 'classnames';

import classes from './NavigationToggle.module.scss';

export type NavigationToggleButtonProps = NavigationToggleType & {
  controlsId: string;
};

export default function NavigationToggle(props: NavigationToggleButtonProps) {
  const toggleLineClass = 'navigation-toggle__line';
  return (
    <button
      type="button"
      className={classNames(classes['navigation-toggle'], props.isActive && classes['navigation-toggle--open'])}
      data-active={props.isActive ? 'true' : undefined}
      aria-expanded={props.isActive}
      aria-controls={props.controlsId}
      aria-label="Navigation umschalten"
      onClick={props.toggleNavigation}
    >
      <span className={classes[toggleLineClass]}></span>
      <span className={classes[toggleLineClass]}></span>
      <span className={classes[toggleLineClass]}></span>
    </button>
  );
}
